import { useSearchParams } from 'react-router-dom';

import { Button } from '../components/Button.js';
import { Card } from '../components/Card.js';

// Stripe-hosted checkout redirects back here after completion.
// Success: ?session_id=<session_id>
// Cancel:  ?cancelled=true
export const PaymentPage = () => {
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get('session_id');
  const cancelled = searchParams.get('cancelled') === 'true';
  const returnTo = searchParams.get('returnTo');
  const destination = returnTo?.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/feeds';

  if (cancelled) {
    return (
      <div className="mx-auto max-w-prose py-8">
        <Card>
          <div className="text-center">
            <h1 className="text-xl font-medium text-text">Payment Cancelled</h1>
            <p className="mt-2 text-sm text-text-secondary">
              Your payment was cancelled. No charges have been made.
            </p>
            <Button href={destination} className="mt-6">
              Go Back
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  if (!sessionId) {
    return (
      <div className="mx-auto max-w-prose py-8">
        <Card>
          <div className="text-center">
            <h2 className="text-lg font-medium text-text">Invalid Payment Session</h2>
            <p className="mt-2 text-sm text-text-secondary">
              No payment session was provided. Please try subscribing again.
            </p>
            <Button href={destination} className="mt-6">
              Go Back
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-prose py-8">
      <Card>
        <div className="text-center">
          <h1 className="text-xl font-medium text-text">Thank You!</h1>
          <p className="mt-2 text-text-secondary">
            Your subscription is now active. Welcome to The Stone Circle.
          </p>
          <p className="mt-4 text-sm text-text-secondary">
            It may take a moment for your account to update.
          </p>
          <Button href={destination} className="mt-6">
            Start Reading
          </Button>
        </div>
      </Card>
    </div>
  );
};
